import getTheme from 'config/themes/base';

const theme = getTheme();

export default {
  container: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  labelContainer: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
  },
  label: {
    fontWeight: 500,
    color: theme.palette.text.primary,
    marginRight: theme.spacing(0.5),
  },
  tooltipIcon: {
    fontSize: '1rem',
    color: theme.palette.text.secondary,
    cursor: 'help',
  },
  uploadArea: {
    border: `2px dashed ${theme.palette.grey[300]}`,
    borderRadius: theme.spacing(1),
    padding: theme.spacing(3),
    minHeight: '120px',
    textAlign: 'center',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    backgroundColor: theme.palette.grey[50],
    '&:hover': {
      borderColor: theme.palette.primary.main,
      backgroundColor: theme.palette.primary.light + '08',
    },
  },
  backgroundUploadArea: {
    // Keep same height and padding as logo uploader to ensure visual consistency
    minHeight: '120px',
    padding: theme.spacing(3),
  },
  disabledUploadArea: {
    cursor: 'not-allowed',
    opacity: 0.6,
  },
  errorBorder: {
    borderColor: theme.palette.error.main,
    '&:hover': {
      borderColor: theme.palette.error.main,
    },
  },
  dragActive: {
    borderColor: theme.palette.primary.main,
    backgroundColor: theme.palette.primary.light + '12',
  },
  uploadIcon: {
    fontSize: '2rem',
    color: theme.palette.grey[500],
    marginBottom: theme.spacing(1),
  },
  uploadText: {
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(0.5),
    fontWeight: 500,
  },
  uploadHint: {
    color: theme.palette.text.secondary,
  },
  previewContainer: {
    marginTop: theme.spacing(1),
  },
  loadingContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(2),
  },
  loadingText: {
    marginTop: theme.spacing(1),
    color: theme.palette.text.secondary,
  },
  previewBox: {
    position: 'relative',
    display: 'inline-block',
  },
  removeBtn: {
    position: 'absolute',
    top: -8,
    right: -8,
    backgroundColor: theme.palette.error.main,
    color: 'white',
    zIndex: 1,
    '&:hover': {
      backgroundColor: theme.palette.error.dark,
    },
  },
  previewImage: {
    maxWidth: '150px',
    maxHeight: '150px',
    width: 'auto',
    height: 'auto',
    borderRadius: theme.spacing(1),
    border: `1px solid ${theme.palette.grey[300]}`,
  },
  backgroundPreview: {
    maxWidth: '250px',
    maxHeight: '150px',
  },
  helperText: {
    marginTop: theme.spacing(0.5),
    marginLeft: theme.spacing(1.75),
    fontSize: '0.75rem',
    color: theme.palette.text.secondary,
  },
  errorText: {
    color: theme.palette.error.main,
  },
};
